import React, {useEffect, useState} from "react";

import Cookies from "js-cookie";
import moment from "moment";

import {useUser} from "@globals/user";

import {Modal} from "@components/modals";

import WelcomeModal from "./WelcomeModal";
import styles from "./WelcomeModal.scss";

export const WELCOME_MODAL_SHOWN_COOKIE = "welcomeModalShown";

export default function Welcome(): JSX.Element {
  const {user} = useUser();
  const firstLogin = moment(user!.first_login);
  const welcomeModalCutoff = firstLogin.add(2, "hour");
  const isAlreadyShowed = Cookies.get(WELCOME_MODAL_SHOWN_COOKIE);
  const shouldShowWelcomeModal =
    !isAlreadyShowed && moment().isBefore(welcomeModalCutoff);
  const [isWelcomeModalShown, setIsWelcomeModalShown] = useState(
    shouldShowWelcomeModal
  );

  useEffect(() => {
    if (shouldShowWelcomeModal) {
      Cookies.set(WELCOME_MODAL_SHOWN_COOKIE, "true");
    }
  }, [isWelcomeModalShown]);

  return (
    <Modal
      isOpen={isWelcomeModalShown}
      modalComponent={WelcomeModal}
      modalClassName={styles.welcomeModal}
      showCloseButton={false}
      onClose={() => setIsWelcomeModalShown(false)}
    />
  );
}
